(function () {
  const config = window.PXM_ACCOUNT || {};
  const READ_KEY = 'pxm-library-read-v1';
  const FAVORITES_KEY = 'pxm-library-favorites-v1';
  const JOURNEY_KEY = 'pxm-library-journey-v1';
  const MIGRATION_PREFIX = 'pxm-cloud-migrated-v1:';
  let account = null;
  let syncTimer = null;

  function readJson(key, fallback) {
    try {
      const value = JSON.parse(window.localStorage.getItem(key) || 'null');
      return value === null ? fallback : value;
    } catch (error) {
      return fallback;
    }
  }

  function localReading() {
    const journey = readJson(JOURNEY_KEY, {});
    return {
      readIds: readJson(READ_KEY, []),
      favoriteIds: readJson(FAVORITES_KEY, []),
      startedIds: Array.isArray(journey.startedIds) ? journey.startedIds : [],
      depths: journey.depths && typeof journey.depths === 'object' ? journey.depths : {},
      journey: {
        lastGuideId: journey.lastGuideId || null,
        lastDepth: journey.lastDepth || null
      }
    };
  }

  function storeReading(reading) {
    const oldJourney = readJson(JOURNEY_KEY, {});
    const journey = {
      ...oldJourney,
      startedIds: reading.startedIds || [],
      depths: reading.depths || {},
      lastGuideId: reading.journey && reading.journey.lastGuideId || null,
      lastDepth: reading.journey && reading.journey.lastDepth || null
    };
    try {
      window.localStorage.setItem(READ_KEY, JSON.stringify(reading.readIds || []));
      window.localStorage.setItem(FAVORITES_KEY, JSON.stringify(reading.favoriteIds || []));
      window.localStorage.setItem(JOURNEY_KEY, JSON.stringify(journey));
    } catch (error) {
      /* Le compte reste utilisable même si le navigateur refuse le stockage local. */
    }
  }

  async function request(path, options) {
    const response = await fetch(`${config.proxyBase || '/apps/plant-x-me'}${path}`, {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', ...(options && options.headers || {}) },
      ...options
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      const error = new Error(data.error || 'La synchronisation est momentanément indisponible.');
      error.status = response.status;
      throw error;
    }
    return data;
  }

  function announce(type, detail) {
    window.dispatchEvent(new CustomEvent(type, { detail }));
  }

  async function boot() {
    if (!config.loggedIn) {
      announce('pxm:account-ready', { connected: false, reason: 'guest', garden: [] });
      return null;
    }

    try {
      let state = await request('/api/bootstrap');
      const migrationKey = `${MIGRATION_PREFIX}${state.accountKey}`;
      if (!window.localStorage.getItem(migrationKey)) {
        state = await request('/api/reading/merge', {
          method: 'POST',
          body: JSON.stringify(localReading())
        });
        window.localStorage.setItem(migrationKey, '1');
      }
      account = state;
      storeReading(state.reading);
      announce('pxm:account-state', state);
      announce('pxm:account-ready', { connected: true, ...state });
      return state;
    } catch (error) {
      announce('pxm:account-ready', { connected: false, reason: 'error', error, garden: [] });
      return null;
    }
  }

  const ready = boot();

  function scheduleReadingSync() {
    if (!config.loggedIn) return;
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(async () => {
      await ready;
      if (!account) return;
      try {
        account = await request('/api/reading', { method: 'PUT', body: JSON.stringify(localReading()) });
        announce('pxm:account-saved', { area: 'reading' });
      } catch (error) {
        announce('pxm:account-save-error', { area: 'reading', error });
      }
    }, 700);
  }

  window.addEventListener('pxm:reading-changed', scheduleReadingSync);

  window.PXMAccount = {
    ready,
    isLoggedIn: Boolean(config.loggedIn),
    loginUrl: config.loginUrl || '/account/login',
    getState: () => account,
    request,
    async refresh() {
      account = await request('/api/bootstrap');
      announce('pxm:account-state', account);
      return account;
    },
    async addPlant(input) {
      const plant = await request('/api/garden/plants', { method: 'POST', body: JSON.stringify(input) });
      if (account) {
        account.garden = [plant, ...(account.garden || [])];
        announce('pxm:account-state', account);
      }
      return plant;
    },
    async updatePlant(id, input) {
      const plant = await request(`/api/garden/plants/${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify(input) });
      if (account) {
        account.garden = (account.garden || []).filter((item) => item.id !== id || !plant.archivedAt).map((item) => item.id === id ? plant : item);
        announce('pxm:account-state', account);
      }
      return plant;
    },
    async addEvent(plantId, input) {
      const event = await request(`/api/garden/plants/${encodeURIComponent(plantId)}/events`, { method: 'POST', body: JSON.stringify(input) });
      if (account) {
        account.garden = (account.garden || []).map((plant) => plant.id === plantId ? { ...plant, events: [event, ...(plant.events || [])] } : plant);
        announce('pxm:account-state', account);
      }
      return event;
    },
    async uploadImage(file) {
      const allowed = ['image/jpeg', 'image/png', 'image/webp'];
      if (!allowed.includes(file.type)) throw new Error('Choisissez une image JPG, PNG ou WebP.');
      if (file.size > 8000000) throw new Error('Cette image dépasse 8 Mo.');
      const form = new FormData();
      form.append('file', file);
      const response = await fetch(`${config.proxyBase || '/apps/plant-x-me'}/api/uploads/image`, {
        method: 'POST',
        credentials: 'same-origin',
        body: form
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || 'La photo n’a pas pu être envoyée.');
      return data.imageUrl;
    }
  };
})();
